import React, { useEffect, useState, useMemo } from "react";
import HeaderTable from "../DataTable/HeaderTable";
import PaginationComponent from "../DataTable/Pagination";
import SearchTable from "../DataTable/Search";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NepaliDatePicker } from "datepicker-nepali-reactjs";
import "./style.css";
import { changeIndexToNepali, colorScale } from "../../utils";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Api from "../../services/api";

export default function StageTable({ comments, title, isLoading }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 10;
  let gnId = "";

  const headers = [
    { name: "क्र.स.", field: "id", sortable: false },
    { name: "प्रक्रियाको चरण", field: "name", sortable: false },
    { name: "प्रस्तावित मिति", field: "sec", sortable: false },
    { name: "सम्पन्न मिति", field: "comp", sortable: false },
    { name: "नतिजा", field: "score", sortable: false },
  ];
  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) => comment.stage_name.toLowerCase().includes(search.toLowerCase())
        // ||
        // comment.img.toLowerCase().includes(search.toLowerCase())
      );
    }

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

  return (
    <div className="card-layout">
      <ToastContainer />
      <div className="row">
        <div className="col mb-3 col-12 text-center">
          <div className="row table-heading">
            <div className="col-md-6">
              <h1 className="sub-heading">{title}</h1>
            </div>
            <div className="col-md-6 d-flex flex-row-reverse dataTables_search">
              <SearchTable
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          {isLoading ? (
            <h4>Loading...</h4>
          ) : commentsData == "" ? (
            <h4>विवरण उपलब्ध छैन</h4>
          ) : (
            <table className="table table-responsive">
              <HeaderTable
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {commentsData.map((comment, i) => (
                  <tr className="w-100">
                    <th scope="row" style={{ minWidth: "5vw" }} key={comment.id}>
                      {changeIndexToNepali(++i)}
                    </th>
                    <td style={{ minWidth: "20vw", textAlign: "left" }}>
                      {comment.stage_name == "" || comment.stage_name == null
                        ? "नभएको"
                        : comment.stage_name}
                    </td>
                    <td style={{ minWidth: "20vw" }}>
                      {comment.scheduled_date == "" || comment.scheduled_date == null
                        ? "नभएको"
                        : changeIndexToNepali(comment.scheduled_date.slice(0, 10))}
                    </td>
                    <td style={{ minWidth: "20vw" }}>
                      {comment.completion_date == "" || comment.completion_date == null
                        ? "नभएको"
                        : changeIndexToNepali(comment.completion_date.slice(0, 10))}
                    </td>
                    <td style={{ minWidth: "20vw" }}>
                      {comment.score == "" || comment.score == null
                        ? "सम्पन्न"
                        : changeIndexToNepali(comment.score)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
